import { Sport } from '@/interfaces/sport';
import { SportResource, sportResource } from '@/resources/sport.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł dyscyplin
 *
 * @export
 * @class SportModule
 * @extends {EntityModule<Sport, SportResource>}
 */
export class SportModule extends EntityModule<Sport, SportResource> {}

export default new SportModule(sportResource);
